<template>
    <div class="invite-title is-right" v-if="invite">
        <p>
            Sent from <strong>{{ invite.invited_by.name }}</strong> at
            <strong>{{ invite.invited_by.company }}</strong> on
            {{ invite.date }}
        </p>
    </div>
</template>

<script>
export default {
  name: 'InvitedTitle',
  computed: {
    invite () {
      return this.$store.getters.authUser.invite
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/InvitedTitle.vue